import { Stack, Tab, Tabs, Typography } from "@mui/material"
import { Outlet, NavLink, useLocation } from "react-router-dom"
import { ProjectStatusChip } from "../../../../components/ProjectsPage/ProjectStatusChip"
import { TabsStyle } from "../../../../components/ProjectPage/ProjectTabs/style"
import type { IProjectViewerPermissions } from "../../../../api/types/projects"

function buildTabIndex(permissions?: IProjectViewerPermissions): Record<string, number> {
  let index = 0
  const map: Record<string, number> = {}
  if (permissions?.can_edit_content) {
    map.description = index++
    if (permissions.can_manage_team) {
      map.team = index++
    }
    map.images = index++
    map.actionplan = index++
    map.needs = index++
  }
  if (permissions?.can_moderate) {
    map.administration = index++
  }
  return map
}

export const EditProjectTabs = ({
  title,
  projectStatus,
  permissions,
}: {
  title: string
  projectStatus?: string | null
  permissions?: IProjectViewerPermissions
}) => {
  const location = useLocation()
  const tabIndex = buildTabIndex(permissions)

  const currentTab = location.pathname.includes("administration")
    ? tabIndex.administration ?? 0
    : location.pathname.includes("needs")
    ? tabIndex.needs ?? 0
    : location.pathname.includes("actionplan")
    ? tabIndex.actionplan ?? 0
    : location.pathname.includes("images")
    ? tabIndex.images ?? 0
    : location.pathname.includes("team")
    ? tabIndex.team ?? 0
    : tabIndex.description ?? 0

  const getDefaultNeedsRoute = () => `needs/whoneeded`

  const needsSubTab = location.pathname.includes("whatneeded")
    ? 1
    : location.pathname.includes("whoavailable")
    ? 2
    : location.pathname.includes("whatavailable")
    ? 3
    : 0

  const showContentTabs = permissions?.can_edit_content === true
  const showTeam = permissions?.can_manage_team === true
  const showAdministration = permissions?.can_moderate === true

  return (
    <Stack alignItems="center" pt={{ xs: "15px", md: "50px" }} height="100%" px={1.5}>
      <Stack gap={2} maxWidth={{ xs: "736px", md: "840px" }} width="100%" height="100%">
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1} px={{ xs: 0, md: 2.5 }}>
          <Typography variant="h1">{title}</Typography>
          {projectStatus != null && projectStatus !== '' && (
            <ProjectStatusChip status={projectStatus} />
          )}
        </Stack>
        <Stack direction="column" gap={{ xs: 1.5, sm: 2 }}>
          <Tabs
            value={currentTab}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={TabsStyle}
          >
            {showContentTabs && <Tab label="Описание" component={NavLink} to="" />}
            {showTeam && <Tab label="Команда" component={NavLink} to="team" />}
            {showContentTabs && <Tab label="Изображения" component={NavLink} to="images" />}
            {showContentTabs && <Tab label="План действий" component={NavLink} to="actionplan" />}
            {showContentTabs && <Tab label="Нам нужны" component={NavLink} to={getDefaultNeedsRoute()} />}
            {showAdministration && <Tab label="Администрирование" component={NavLink} to="administration" />}
          </Tabs>
          {location.pathname.includes("needs") && showContentTabs && (
            <Tabs
              value={needsSubTab}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={TabsStyle}
            >
              <Tab label="Кто нужен" component={NavLink} to="needs/whoneeded" />
              <Tab label="Что нужно" component={NavLink} to="needs/whatneeded" />
              <Tab label="Кто уже есть" component={NavLink} to="needs/whoavailable" />
              <Tab label="Что уже есть" component={NavLink} to="needs/whatavailable" />
            </Tabs>
          )}
        </Stack>
        <Outlet />
      </Stack>
    </Stack>
  )
}
